import React from "react";
import Marquee from "react-fast-marquee";
import styled from "styled-components";

const devIconData = [
  { icon: "/images/itsolutions_icon/dev_icon/react 1.png", title: "React" },
  { icon: "/images/itsolutions_icon/dev_icon/next 1.png", title: "Next.js" },
  { icon: "/images/itsolutions_icon/dev_icon/vue 1.png", title: "Vue.js" },
  {
    icon: "/images/itsolutions_icon/dev_icon/flutter 1.png",
    title: "Flutter",
  },
  { icon: "/images/itsolutions_icon/dev_icon/unity 1.png", title: "Unity" },
  {
    icon: "/images/itsolutions_icon/dev_icon/android 1.png",
    title: "Android",
  },
  { icon: "/images/itsolutions_icon/dev_icon/apple 1.png", title: "Apple" },
  {
    icon: "/images/itsolutions_icon/dev_icon/spring 1.png",
    title: "Spring Boot",
  },
  { icon: "/images/itsolutions_icon/dev_icon/go 2.png", title: "Golang" },
  { icon: "/images/itsolutions_icon/dev_icon/py 1.png", title: "Python" },
  { icon: "/images/itsolutions_icon/dev_icon/aws 2.png", title: "AWS" },
];

const extendedData = [...devIconData, ...devIconData];

// 🌈 스타일 정의
const CarouselWrapper = styled.div`
  width: 100%;
  padding: 10px 0;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

const CarouselItem = styled.div`
  display: flex;
  flex-direction: column;
  flex: 0 0 auto;
  justify-content: flex-start;
  width: 100px;
  margin: 0 10px;
  gap: 10px;
`;

const Image = styled.img`
  width: 100%;
  border-radius: 10px;
  width: 100px;
  height: 100px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

const Text = styled.div`
  height: 60px;
  font-size: 20px;
  font-weight: bold;
  color: white;
  text-align: center;
`;
// ⚛️ 화살표 함수 형태의 컴포넌트
const MobileTech = () => {
  return (
    <CarouselWrapper>
      <Marquee speed={50} pauseOnHover={true} gradient={false}>
        {extendedData.map((icon, index) => (
          <CarouselItem key={index}>
            <Image src={icon.icon} alt={`company-${index}`} />
            <Text>{icon.title}</Text>
          </CarouselItem>
        ))}
      </Marquee>
    </CarouselWrapper>
  );
};

export default MobileTech;
